@if (url) {
  <iframe class="pl-iframe"
    [src]="url">
  </iframe>
}

